import { withHandlers } from 'recompose';
import { SubmissionError } from 'redux-form';

import { IntlProps } from 'ha/i18n';
import buildParams from 'ha/utils/buildParams';
import reportError from 'ha/helpers/bugsnag/reportError';
import { submitSearch } from 'ha/modules/SearchListings/actions';
import { RequestError } from 'ha/services/apiV2';
import { ShowAlert, AlertType } from 'ha/modules/Alertbar/types';

import { FormValues } from '../../components/SearchBar';
import { ErrorMessages } from '../../constants';

export interface Props extends IntlProps {
  onSubmit: (
    place: string,
    languages: string[],
  ) => ReturnType<ReturnType<typeof submitSearch>>;
  currentLanguage: string;
  changeLocation: (location: string) => void;
  sendAlert: (alert: ShowAlert) => void;
}

export const onSubmit = (props: Props) => ({
  dateRange,
  place,
}: FormValues) => {
  const {
    currentLanguage,
    intl: { urlResolver, formatDate, lang },
  } = props;

  return props
    .onSubmit(place, [currentLanguage])
    .then(({ data: city }) => {
      const { cityName, countryName } = city[lang];
      const nextUrl = `${urlResolver.getSearchUrl(cityName, countryName)}`;

      const params = buildParams({
        startDate: dateRange.startDate
          ? formatDate('YYYY-MM-DD', dateRange.startDate)
          : null,
        endDate: dateRange.endDate
          ? formatDate('YYYY-MM-DD', dateRange.endDate)
          : null,
      });

      return `${nextUrl}${params}`;
    })
    .catch(e => {
      throw new SubmissionError(e);
    });
};

export const onSubmitSuccess = (props: Props) => (nextLocation: string) => {
  props.changeLocation(nextLocation);
};

export const onSubmitFail = (props: Props) => (error: RequestError) => {
  if (error.status === 404) {
    props.sendAlert({
      text: ErrorMessages.SEARCH_NOT_FOUND,
      kind: AlertType.Warning,
      dismissAfter: 5000,
    });
  } else {
    reportError('Search listings onSubmitFail', { metaData: { error } });
  }
};

export default withHandlers({
  onSubmit,
  onSubmitSuccess,
  onSubmitFail,
});
